import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter,
  Input, Output, ViewChild,
} from '@angular/core';
import * as _ from 'lodash';

import { columns } from './product-columns';
import { BaseModalComponent } from 'shared/modal/_base-modal.component';
import { ProductsSearchComponent } from '../products-search/products-search.component';
import { ProductListsSearchComponent } from '../product-lists-search/product-lists-search.component';
import {ProductPanelComponent} from '../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'assign-to-products-modal',
  templateUrl: 'assign-to-products-modal.component.html',
  styleUrls: ['assign-to-products-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignToProductsModalComponent extends BaseModalComponent {

  @Output() assignToProducts: EventEmitter<any> = new EventEmitter();
  @Output() assignToProductLists: EventEmitter<any> = new EventEmitter();
  @Output() openProductLists: EventEmitter<any> = new EventEmitter();

  @ViewChild(ProductsSearchComponent, {static: false})
  productsSearch: ProductsSearchComponent | void;

  @ViewChild(ProductListsSearchComponent, {static: false})
  productListsSearch: ProductListsSearchComponent | void;

  isListsSearch: boolean = false;
  productResultColumns: Array<any> = columns;

  constructor(
    private ref: ChangeDetectorRef,
  ) {
    super();
  }

  get disabledAssign(): boolean {
    if (!this.productListsSearch || !this.productsSearch) { return true; }
    return this.isListsSearch ?
    !this.filteredSelectedIds.length :
    !this.productsSearch.selectedRows.length;
  }

  get filteredSelectedIds(): Array<string> {
    return this.productListsSearch && _.intersection(this.productListsSearch.filteredIds, this.productListsSearch.selectedIds) || [];
  }

  show() {
    super.show();
    _.defer(() => {
      if (this.productsSearch) {
        this.productsSearch.startSearch();
      }
      this.ref.markForCheck();
    });
  }

  hide() {
    super.hide();
    if (this.productsSearch) {
      this.productsSearch.resetData();
    }
    if (this.productListsSearch) {
      this.productListsSearch.resetData();
    }
    this.isListsSearch = false;
  }

  // handlers
  onAssignBtnClick() {
    if (this.disabledAssign) { return; }
    if (this.isListsSearch) {
      this.assignToProductLists.emit(this.filteredSelectedIds);
    } else {
      if (this.productsSearch) {
        this.assignToProducts.emit(this.productsSearch.selectedRows);
      }
    }
  }

  onProductListsOpen() {
    this.isListsSearch = true;
    if (this.productListsSearch) {
      this.productListsSearch.fetchLists();
    }
    this.ref.markForCheck();
  }

  onProductListsClose() {
    this.isListsSearch = false;
    if (this.productListsSearch) {
      this.productListsSearch.resetData();
    }
    this.ref.markForCheck();
  }
}
